export const FONT_OPTIONS = [
  { label: 'Roboto', value: "'Roboto', sans-serif" },
  { label: 'Merriweather', value: "'Merriweather', serif" },
  { label: 'Courier Prime', value: "'Courier Prime', monospace" },
  { label: 'Comic Neue', value: "'Comic Neue', cursive" },
  { label: 'Lobster', value: "'Lobster', cursive" },
];
